import tenantUpdates from '../slices/tenantUpdates';
import type { RootStateType, ThunkDispatchType } from '../index';

import { getTenantUpdates } from '../../api-admin/tenant-updates';

// eslint-disable-next-line import/prefer-default-export
export function fetchAllTenantUpdates() {
    return async (dispatch: ThunkDispatchType) => {
        try {
            dispatch(tenantUpdates.actions.fetchAll());
            const data = await getTenantUpdates();
            dispatch(tenantUpdates.actions.allFetched({ data }));
        } catch (e) {
            console.log('ERROR fetching tenant updates', e);
            dispatch(tenantUpdates.actions.allFetched({ data: [] }));
        }
    };
}

export const selectAllTenantUpdates = () => (
    state: RootStateType
) => state.tenantUpdates.all;

export const selectFetchingAllTenantUpdates = () => (
    state: RootStateType
) => state.tenantUpdates.fetchingAll;
